export default __webpack_public_path__ + "static/media/black-cancel-request-icon.17479bdc.svg";